import React from 'react';
import { string, node } from 'prop-types';
import { Helmet } from 'react-helmet';

const DEFAULT_TITLE = 'Staq Developer Portal';
const DEFAULT_DESC = 'With Staq you can deploy innovative digital banking products or embed financial services into your customer experience at extraordinary speed. Get started today';

function HeadWrapper({ title, description, href, children }) {
  return (
    <Helmet>
      {/* <meta charSet="utf-8" /> */}
      <title>{title}</title>
      <link rel="canonical" href={href} />
      <meta name="description" content={description} />
      {children}
    </Helmet>
  );
}

HeadWrapper.propTypes = {
  href: string.isRequired,
  children: node,
  title: string,
  description: string,
};

HeadWrapper.defaultProps = {
  title: DEFAULT_TITLE,
  description: DEFAULT_DESC

};

export default HeadWrapper;
